import { fetchJSON as fetchAPI } from './client';

const RUNTIME_BASE = import.meta.env.VITE_RUNTIME_API ?? 'http://localhost:8159';

export type DomainOwnership = {
  domain: string;
  owner: string;
  aggregates: Array<{ name: string; description?: string; events?: string[] }>;
  api_prefix: string;
  event_prefix: string;
};

export type DuplicateEntry = {
  service_id: string;
  canonical_id: string;
  reason: string;
  status: string;
  capabilities?: string[];
};

export type ConsolidationAudit = {
  total_duplicates: number;
  consolidated: number;
  remaining_adapters: number;
  entries: DuplicateEntry[];
};

export type DependencyGraph = {
  nodes: string[];
  edges: Array<{ from: string; to: string }>;
  cycles: Array<{ from: string; to: string }>;
  valid: boolean;
};

export type ConsolidationDashboard = {
  total_domains: number;
  total_modules: number;
  duplicates_audited: number;
  circular_deps: number;
  dependency_graph: DependencyGraph;
  audit: ConsolidationAudit;
  reference_data: {
    order_statuses: string[];
    inventory_states: string[];
    currencies: string[];
    marketplace_types: string[];
  };
};

export type ConsolidationReport = {
  module_id: string;
  canonical_owner: string;
  owned_aggregates: string[];
  shared_services: string[];
  namespace_valid: boolean;
  dependencies_valid: boolean;
  duplicates_resolved: number;
};

function fetchRuntime<T>(path: string): Promise<T> {
  return fetchAPI<T>(RUNTIME_BASE, path);
}

export const consolidationApi = {
  registry: () => fetchRuntime<{ domains: DomainOwnership[]; version: string }>('/api/v1/consolidation/registry'),
  audit: () => fetchRuntime<ConsolidationAudit>('/api/v1/consolidation/audit'),
  dependencies: () => fetchRuntime<DependencyGraph>('/api/v1/consolidation/dependencies'),
  dashboard: () => fetchRuntime<ConsolidationDashboard>('/api/v1/consolidation/dashboard'),
  moduleReport: (id: string) => fetchRuntime<ConsolidationReport>(`/api/v1/consolidation/modules/${id}`),
};
